import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, MenuProps, Space } from 'antd';
import { FC, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiReqSearchAdvertisementForMain } from 'src/api/management.api';
import ApiTable, { ApiTableRef } from 'src/components/core/apiTable/ApiTable';
import { LocaleFormatter, useLocale } from 'src/locales';
import MainAdGraph from './MainAdGraph';

const tableColums = [
   { title: <LocaleFormatter id="menu.dashboard.AdStatus.row.adName" />, width: '22%', dataIndex: 'name', key: 'name', align: 'center', render: (data: string) => <span className='ellipsesTableContents'>{data}</span> },
   { title: "재생", width: '12%', dataIndex: 'playCount', key: 'playCount', align: 'center' },
   { title: "시청", width: '12%', dataIndex: 'viewCount', key: 'viewCount', align: 'center' },
   { title: "URL 클릭", width: '12%', dataIndex: 'urlCount', key: 'urlCount', align: 'center' },
   { title: "QR 클릭", width: '12%', dataIndex: 'qrCount', key: 'qrCount', align: 'center' },
   { title: <LocaleFormatter id="menu.dashboard.AdStatus.row.deviceCount" />, dataIndex: 'deviceCount', key: 'deviceCount', align: 'center', width: '7.5%' },
]

const MainAdList: FC = () => {
   const navigate = useNavigate();
   const { formatMessage } = useLocale();
   const apiTableRef = useRef<ApiTableRef>();
   const [currentMenu, setCurrentMenu] = useState<string>(formatMessage({ id: 'menu.dashboard.AdStatus.today' }));
   const [graphData, setGraphData] = useState<any[]>([]);

   const items = [
      { label: formatMessage({ id: 'menu.dashboard.AdStatus.today' }), key: '1', period: 1 },
      { label: formatMessage({ id: 'menu.dashboard.AdStatus.week' }), key: '2', period: 7 },
      { label: formatMessage({ id: 'menu.dashboard.AdStatus.month' }), key: '3', period: 30 },
   ];

   useEffect(() => {
      console.log('useEffect!!!');
      apiTableRef.current?.setApiParam({ period: 1 });
   }, []);

   const handleMenuClick: MenuProps['onClick'] = e => {
      console.log('handleMenuClick');
      let item = items[Number(e.key) - 1];
      setCurrentMenu(item.label);
      apiTableRef.current?.setApiParam({ period: item.period });
   };

   return (
      <>
         <div className='mainListTitle' style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Dropdown menu={{items, onClick: handleMenuClick}} trigger={['click']}>
               <Button><Space>{currentMenu}<DownOutlined /></Space></Button>
            </Dropdown>
            <span style={{ cursor: 'pointer', marginTop: '5px' }} onClick={() => navigate('/dataManagement/adBasedDataMng')}>더보기</span>
         </div>
         <ApiTable
            pageApi={apiReqSearchAdvertisementForMain}
            ref={apiTableRef}
            pageItemCnt={5}
            columns={tableColums}
            combineSearchButton
            onDataFetched={(data) => setGraphData(data)}
         />
        <MainAdGraph data={graphData} loading={false} />
      </>
   );
}

export default MainAdList;
